document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll('.mobile-faq');
  if (!containers.length) return;

  containers.forEach(container => {
    const elements = Array.from(container.children);
    let newHTML = '';

    for (let i = 0; i < elements.length; i++) {
      if (elements[i].tagName === 'H2') {
        let title = elements[i].outerHTML;
        let content = '';

        let j = i + 1;

        // collect all content until next H2
        while (
          elements[j] &&
          elements[j].tagName !== 'H2'
        ) {
          content += elements[j].outerHTML;
          j++;
        }

        i = j - 1; // skip processed elements

        newHTML += `
          <div class="faq-block">
            ${title}
            <div class="faq-content">${content}</div>
          </div>
        `;
      }
    }

    container.innerHTML = newHTML;
  });

  // toggle
  document.querySelectorAll('.faq-block h2').forEach(title => {
    title.addEventListener('click', () => {
      if (window.innerWidth <= 768) {
        title.parentElement.classList.toggle('active');
      }
    });
  });
});


window.addEventListener("scroll", function () {

    const nav = document.querySelector(".stycy-nav");

    let scrollLimit;

    // Check screen width
    if (window.innerWidth <= 768) {
        scrollLimit = 200; // mobile
    } else {
        scrollLimit = 200; // desktop
    }

    // Sticky class
    if (window.scrollY > scrollLimit) {
        nav.classList.add("sticky-nav");
    } else {
        nav.classList.remove("sticky-nav");
    }

    // Active menu on section reach
    const sections = document.querySelectorAll("section[id]");
    const navLinks = document.querySelectorAll(".stycy-nav a");

    let currentSection = "";

    sections.forEach(section => {

        const sectionTop = section.offsetTop - 250;
        const sectionHeight = section.offsetHeight;

        if (
            window.scrollY >= sectionTop &&
            window.scrollY < sectionTop + sectionHeight
        ) {
            currentSection = section.getAttribute("id");
        }

    });

    navLinks.forEach(link => {

        link.classList.remove("active");

        if (
            link.getAttribute("href") === "#" + currentSection
        ) {
            link.classList.add("active");
        }

    });

});



(function () {

  const menus = document.querySelectorAll('.jump-menu');

  let firstClick = true;

  menus.forEach(menu => {

    const links = menu.querySelectorAll('a');

    links.forEach(link => {

      link.addEventListener('click', function (e) {

        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));

        if (!target) return;

        // Mobile check
        const isMobile = window.innerWidth < 768;

        // Offset values
        let OFFSET;

        if (firstClick) {
          OFFSET = isMobile ? 250 : 350;
        } else {
          OFFSET = isMobile ? 120 : 170;
        }

        const topPosition = target.offsetTop - OFFSET;

        // Smooth scroll
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });

        // Active class
        links.forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        // MOBILE accordion auto open
        if (isMobile) {

          // Find accordion item inside target section
          const accordionItem = target.querySelector('.acc-item');

          if (accordionItem) {

            // Close all accordions
            document.querySelectorAll('.acc-item').forEach(item => {
              item.classList.remove('active');
            });

            // Open current accordion
            setTimeout(() => {
              accordionItem.classList.add('active');
            }, 400);

          }

        }

        firstClick = false;

      });

    });

  });

})();


document.addEventListener("DOMContentLoaded", function () {

  const menuLinks = document.querySelectorAll(
    '.desktop-navbar .has-dropdown > .desktop-navbar__link'
  );

  menuLinks.forEach(function(link){

    link.addEventListener('click', function(e){

      e.preventDefault();

      const parent = this.parentElement;

      // close other menus
      document.querySelectorAll('.desktop-navbar__item')
      .forEach(function(item){

        if(item !== parent){
          item.classList.remove('active');
        }

      });

      // toggle current menu
      parent.classList.toggle('active');

    });

  });

});
history.scrollRestoration = "manual";

const handleDirectScroll = () => {
  if (window.location.hash === "#video") {
    const target = document.querySelector("#video");
    if (!target) return;

    // Mobile = 100px, Desktop = 190px
    const offset = window.innerWidth <= 768 ? 100 : 190;

    const topPosition =
      target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: topPosition,
      behavior: "auto"
    });
  }
};

window.addEventListener("DOMContentLoaded", handleDirectScroll);
window.addEventListener("load", handleDirectScroll);

setTimeout(handleDirectScroll, 100);
setTimeout(handleDirectScroll, 400);